import React, { memo, useState } from "react";
import SkeletonImg from "./Skeletons/SkeletonImg";

const DImage = ({ src, alt, load = false, className, ...rest }) => {
    const [loading, setLoading] = useState(true);
    return (
        <>
            {load && loading && <SkeletonImg />}
            <img
                {...rest}
                src={src}
                onLoad={() => setLoading(false)}
                alt={alt}
                className={`${className} relative ${
                    load ? (loading ? "-z-10" : "z-0") : ""
                }`}
            />
        </>
    );
};

export default memo(DImage);
